import React from 'react';
import Viewer from '../Manage/Content/Viewer';
import GhostHomePage from './GhostHomePage';

const Index = () => {
  return (        
        <GhostHomePage
          fallback={<Viewer url={process.env.REACT_APP_HOME_PAGE_KEY} showSkeleton={true} />}
        />
    )
}
export default Index;
